// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__18hF6","colMaxWidth":"Table_colMaxWidth__2ABdl"};